import React from 'react'
import { useNavigate } from 'react-router-dom'
import { plusGray } from '../../../assets'
import { CustomButton, CustomEmptyDataComponent, CustomHeading } from '../../../common/custom'
import CustomContainer from '../../../common/custom/CustomContainer'
import CustomTable from '../../../common/custom/CustomTable/custom-table.component'
import { LEASEPROTECTIONPOLICY, LEASEPROTECTIONPOLICYLEADS } from '../../../constants/columns'
import { PATHS } from '../../../constants/paths'
import LeaseProtectionActionMenu from './lease-protection-action-menu'
import { useLeaseProtectionListing } from './useLeaseProtectionListing'
import ViewAttachmentsModal from '../../../common/custom/Modals/ViewAttachmentsModal/modal'
import PreviewFullImageModal from '../../../common/custom/Modals/PreviewFullImage/modal'

const LeaseProtectionPolicyListing = () => {
    const navigate = useNavigate();
    const {
        loading,
        handleActionClick,
        currentTab, setCurrentTab,
        leaseProtectionActionClickedData,
        leaseProtectionActionClickedId,
        isViewContractModal,
        setIsViewContractModal,
        actionMenuRef,
        contractAttachemnts,
        leaseProtectionCoverages,
        toggleActionMenu,
        handleDownload,
        handleViewContract,
        handleDownloadCertificate
    } = useLeaseProtectionListing();

    const handleTabSwitch = (tab) => {
        setCurrentTab(tab);
    };

    const leadsData = leaseProtectionCoverages?.filter(item => !item?.isReported || item?.isReported === null || item?.isReported === undefined)
    const leaseProtectionData = leaseProtectionCoverages?.filter(item => item?.isReported && item?.isReported !== null && item?.isReported !== undefined)
    return (
        <div>
            <div className=' border-2 border-[#EAECF0] rounded-[7px]'>
                <CustomContainer className='px-6 min-h-[75px] flex justify-between items-center gap-2 flex-wrap md:flex-nowrap'>
                    <CustomHeading className='text-foundation-black font-inter text-small-heading font-[600]   max-w-[1152px] w-full h-full'>
                        Lease Protection Coverages
                    </CustomHeading>
                    {/* <div className='flex w-auto justify-end'>
                        <div
                            className={`p-2 mr-2 flex w-[150px] justify-center items-center text-small-para font-[500] text-filter-heading cursor-pointer ${currentTab === 'leads'
                                ? 'bg-[#F1EEEC] text-foundation-brown rounded-md'
                                : 'text-filter-heading'
                                }`}
                            onClick={() => { handleTabSwitch('leads'); }}
                        >
                            Leads
                        </div>
                        <div
                            className={`p-2 mr-2 flex w-[150px] justify-center items-center text-small-para font-[500] text-filter-heading cursor-pointer ${currentTab === 'coverages'
                                ? 'bg-[#F1EEEC] text-foundation-brown rounded-md'
                                : 'text-filter-heading'
                                }`}
                            onClick={() => { handleTabSwitch('coverages'); }}
                        >
                            Coverages
                        </div>
                    </div> */}
                    {/* <CustomHeading className='text-foundation-black font-inter text-small-heading font-[600]   max-w-[1152px] w-full h-full'>
                        Coverages
                    </CustomHeading> */}
                    <CustomButton
                        onClick={() => navigate(PATHS.ADDLEASEPROTECTIONPOLICY)}
                        icon={plusGray}
                        className=' bg-foundation-white  px-[16px]  w-fit flex-shrink-0 rounded-[8px] border  border-[#D0D5DD] h-[40px] flex justify-between items-center text-[14px] font-[500]  gap-3'
                        text={'Create New LPP'}
                    />
                </CustomContainer>
                <div className=' overflow-x-auto'>
                    {leaseProtectionData?.length ? (
                        <CustomTable header={currentTab === "leads" ? LEASEPROTECTIONPOLICYLEADS : LEASEPROTECTIONPOLICY}
                            // rows={currentTab === "leads" ? leaseProtectionCoverages?.filter(item => (!item.leaseNo || item.leaseNo === undefined || item.leaseNo === null))
                            //     : leaseProtectionCoverages?.filter(item => (item.leaseNo && item.leaseNo !== undefined && item.leaseNo !== null))}
                            rows={leaseProtectionData}
                            {...{ handleActionClick, toggleActionMenu }}
                            actionMenuRef={actionMenuRef}
                            menu={
                                <LeaseProtectionActionMenu
                                    handleDownload={handleDownload}
                                    handleView={handleViewContract}
                                    data={leaseProtectionActionClickedData}
                                    handleDownloadCertificate={handleDownloadCertificate}
                                    upper={false}
                                    currentTab={currentTab}
                                />
                            }
                            table='leaseCoverages' />
                    ) : loading ? (
                        <CustomEmptyDataComponent
                            heading='Loading data...'
                            loading={true}
                        ></CustomEmptyDataComponent>
                    ) : (
                        <CustomContainer >
                            <CustomContainer className='min-h-[620px] flex justify-center items-center  '>
                                <CustomContainer className='max-w-[399px] min-h-[355px]  w-full flex flex-col items-center'>
                                    <CustomHeading className='whitespace-nowrap text-large-heading sm:text-medium-heading md:text-large-heading font-roboto font-[500] text-foundation-black '>
                                        No Data Found!
                                    </CustomHeading>
                                </CustomContainer>
                            </CustomContainer>
                        </CustomContainer>
                    )}{' '}
                </div>
            </div>
            <div className=' border-2 border-[#EAECF0] rounded-[7px] mt-6'>
                <CustomContainer className='px-6 min-h-[75px] flex justify-between items-center gap-2 flex-wrap md:flex-nowrap'>
                    <CustomHeading className='text-foundation-black font-inter text-small-heading font-[600]   max-w-[1152px] w-full h-full'>
                        Applications
                    </CustomHeading>
                </CustomContainer>
                <div className=' overflow-x-auto'>
                    {leadsData?.length ? (
                        <CustomTable header={LEASEPROTECTIONPOLICYLEADS}
                            // rows={currentTab === "leads" ? leaseProtectionCoverages?.filter(item => (!item.leaseNo || item.leaseNo === undefined || item.leaseNo === null))
                            //     : leaseProtectionCoverages?.filter(item => (item.leaseNo && item.leaseNo !== undefined && item.leaseNo !== null))}
                            rows={leadsData}
                            {...{ handleActionClick, toggleActionMenu }}
                            actionMenuRef={actionMenuRef}
                            menu={
                                <LeaseProtectionActionMenu
                                    handleDownload={handleDownload}
                                    handleView={handleViewContract}
                                    data={leaseProtectionActionClickedData}
                                    handleDownloadCertificate={handleDownloadCertificate}
                                    upper={false}
                                    currentTab={"leads"}
                                />
                            }
                            table='leaseCoverages' />
                    ) : loading ? (
                        <CustomEmptyDataComponent
                            heading='Loading data...'
                            loading={true}
                        ></CustomEmptyDataComponent>
                    ) : (
                        <CustomContainer >
                            <CustomContainer className='min-h-[620px] flex justify-center items-center  '>
                                <CustomContainer className='max-w-[399px] min-h-[355px]  w-full flex flex-col items-center'>
                                    <CustomHeading className='whitespace-nowrap text-large-heading sm:text-medium-heading md:text-large-heading font-roboto font-[500] text-foundation-black '>
                                        No Data Found!
                                    </CustomHeading>
                                </CustomContainer>
                            </CustomContainer>
                        </CustomContainer>
                    )}
                </div>
            </div>
            {isViewContractModal && (
                <PreviewFullImageModal
                    title="View Contract"
                    show={isViewContractModal}
                    file={contractAttachemnts}
                    onClose={() => setIsViewContractModal(false)}
                />
            )}
        </div>
    )
}

export default LeaseProtectionPolicyListing